'use client';
import { useQuery } from '@tanstack/react-query';

import { electionsApi } from '@/services/api/elections.api';
import { EventsListResponse, MarketsQueryParams } from '@/types';

// Query Keys Factory
export const ELECTION_QUERY_KEYS = {
  all: ['elections'] as const,
  lists: () => [...ELECTION_QUERY_KEYS.all, 'list'] as const,
  list: (params: Partial<MarketsQueryParams>) => [...ELECTION_QUERY_KEYS.lists(), params] as const,
};

/**
 * Fetch elections list
 */
export const useElections = (params?: Partial<MarketsQueryParams>) => {
  return useQuery({
    queryKey: ELECTION_QUERY_KEYS.list(params || {}),
    queryFn: async () => {
      return electionsApi.getElections(params);
    },
    select: (response: EventsListResponse) => response?.data ?? [],
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 30,
  });
};
